module.exports = __webpack_public_path__ + "img/vida-verd-01.01754c02.jpg";